
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.445 4.197H4.288c-1.047 0-1.897.85-1.897 1.898v16.008c0 1.047.85 1.897 1.897 1.897h11.157c1.047 0 1.898-.85 1.898-1.897V6.095a1.905 1.905 0 00-1.898-1.898zm.566 17.9a.57.57 0 01-.57.571H4.283a.57.57 0 01-.57-.57V6.095a.57.57 0 01.57-.57H15.44a.57.57 0 01.57.57v16.003z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M19.712 0H8.554C7.508 0 6.657.85 6.657 1.897a.66.66 0 00.664.664.66.66 0 00.663-.664.57.57 0 01.57-.57h11.158a.57.57 0 01.57.57v16.008a.57.57 0 01-.57.57.66.66 0 00-.664.664.66.66 0 00.664.664c1.047 0 1.897-.85 1.897-1.898V1.897C21.609.85 20.759 0 19.712 0z","fill":"#E2E4EC"}})])
          )
        }
      }
    